export default "__VITE_ASSET__DZLXPrHc__"